import React, { useMemo } from "react";
import './hello.scss'; // 导入样式文件

const Hello = ({ messagelist, showStatus, helloImage }) => {
    return (
        <div className="hello_message_">
            <div className="hello_message_list_">
                {messagelist.length > 0 && (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="hello_message_title_div">
                            <img className="hello_message_avatar" src={helloImage} />
                            {messagelist && (
                                <span className="hello_message_content_blod" dangerouslySetInnerHTML={{ __html: messagelist[0].content }} />
                            )}
                        </div>
                        {messagelist.length > 1 && (
                            <span className="hello_message_content_" dangerouslySetInnerHTML={{ __html: messagelist[1].content }} />
                        )}
                        <br />
                    </div>
                )}
            </div>
            {messagelist.length > 1 && (
                <div className="hello_message_person_">
                    <div className="hello_message_chat_button_" onClick={showStatus}>
                        <span>Let's chat with me</span>
                    </div>
                </div>
            )}

        </div>
    );
};

export default Hello;